export default __webpack_public_path__ + "00d75c0c3f009fbd83d2af05597a8e8e.svg";